import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DisplayBrowserChromeComponent } from '../../../preview-common/display/display-browser-chrome/display-browser-chrome.component';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

@Component({
    selector: 'app-gen-display-ad-mobile-21',
    imports: [CommonModule, MobileFrameComponent, DisplayBrowserChromeComponent],
    templateUrl: './display-ad-mobile-21.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/display/display-mobile-styles.scss',
        './display-ad-mobile-21.component.scss',
    ]
})
export class DisplayAdMobile21PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /** This placement's creative slot is the square format. */
  readonly creativeFormat: CreativeFormat = 'square';

  /** Full dimensions, carried as the placeholder's tooltip. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** This slot is a thumbnail — too narrow for the pixel label, so it shows the ratio. */
  readonly missingDimensionShortLabel = CreativeImageRouterHelper.shortLabelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  /**
   * Row counts for the grey article text the ad is embedded in — the mock shows
   * a paragraph above the ad, ending on a short line, and a longer run below it.
   * Sixteen rows is what fills the rest of this frame without the last one
   * clipping. Only the counts matter, so the arrays are empty on purpose.
   */
  readonly topBars = Array.from({ length: 8 });
  readonly bottomBars = Array.from({ length: 16 });
}
